export default __webpack_public_path__ + "static/media/Content_upload.0fbacae8.svg";